import { Link } from 'wouter';
import { ChevronLeft } from 'lucide-react';

const PARENT_LABELS: Record<string, string> = {
  insights: 'Insights',
  services: 'Services',
  'about-me': 'About',
};

interface BackToParentButtonProps {
  pageSlug: string;
}

export function BackToParentButton({ pageSlug }: BackToParentButtonProps) {
  const label = PARENT_LABELS[pageSlug] ?? pageSlug;
  return (
    <div className="not-prose mt-12 flex justify-start">
      <Link
        href={`/${pageSlug}`}
        className="inline-flex items-center gap-2 bg-[#2D7E32] text-white font-semibold px-5 py-2.5 rounded-full hover:opacity-90 transition-opacity text-sm shadow-sm group"
      >
        <ChevronLeft className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" aria-hidden="true" />
        Back to {label}
      </Link>
    </div>
  );
}
